import { head } from 'lodash'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'
import { RootState } from 'redux/store'
import { Show } from 'data/Show'
import { showHasEnded, showHasStarted } from 'utils/show'
import moment from 'moment'
import { groupBy } from 'lodash'

interface ShowsState {
    list: Show[] | null
    featured: Show | null
    recent: Show[]
    categories: {
        [key: string]: Show[]
    }
}

export const initialState: ShowsState = {
    list: null,
    featured: null,
    recent: [],
    categories: {},
}

const showsSlice = createSlice({
    name: 'shows',
    initialState,
    reducers: {
        showsReceived: (state, { payload: shows }: PayloadAction<Show[]>) => {
            state.list = shows.sort((showLeft, showRight) =>
                moment(showRight.startTime).diff(moment(showLeft.startTime)),
            )

            const recentShows = state.list.filter(showHasEnded)
            const upcomingShows = state.list
                .filter(show => !showHasStarted(show) || (showHasStarted(show) && !showHasEnded(show)))
                .reverse()
            const categories = groupBy(upcomingShows, 'category')
            const featuredShow =
                state.list.find(show => show.featured) || head(upcomingShows) || head(recentShows) || null

            state.categories = categories
            state.featured = featuredShow
            state.recent = recentShows
        },
    },
})

const { actions, reducer } = showsSlice

export default reducer

export const getShowsState = (store: RootState) => store.shows

export const getShows = createSelector(getShowsState, shows => shows.list)

export const getFeaturedShow = createSelector(getShowsState, shows => shows.featured)

export const getPastShows = createSelector(getShowsState, shows => shows.recent)

export const getCategories = createSelector(getShowsState, shows => shows.categories)

export const { showsReceived } = actions
